import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../Hero/Hero.module.css";
import man_with_hammer from "../../images/man_with_hammer.png";
import heroSection from "../../Data/selectCity (1).json";
import her02_image from "../../Data/selectCity (1).json";
import bottomBanner2_img from "../../images/bottom_banner2.png";

//retrieving data from json file
const jsonData = heroSection[0].heroSection;

const dropdownData = heroSection[0].heroSection.form[0].dropdownItem;

// console.log(dropdownData);
const Hero = () => {
  const [cityValue, setCityValue] = useState("");
  console.log(cityValue);

  let navigate = useNavigate();
  return (
    <>
      <div className={styles.container}>
        <div className={styles.left}>
          <img src={man_with_hammer} alt="man_with_hammer" />
        </div>
        <div className={styles.right}>
          <div className={styles.right_Top}>
            <h1 id={styles.heading}>{jsonData.title}</h1>
            <h1 id={styles.heading_2}>{jsonData.heading}</h1>
            <h1 id={styles.heading_3}>{jsonData.description} </h1>
          </div>

          <div className={styles.select_City}>
            <h4>Where do you need a service?</h4>
            <select
              name=""
              id={styles.dropdownItems}
              onChange={(e) => setCityValue(e.target.value)}
            >
              <option selected disabled={true} value="">
                Select your location
              </option>
              <option value={dropdownData}>{dropdownData}</option>
            </select>

            {/* //checking  drpdown value  */}
            {cityValue?.length > 0 ? navigate("/delhi-ncr") : ""}
          </div>
        </div>
      </div>
      <div className={styles.Bottom_Banner}>
        <img
          src={her02_image[0]?.banner5.webImg}
          alt={her02_image[0]?.banner5.altText}
        />
      </div>
      {/* this container for only mobile devices... */}
      <div className={styles.Bottom_Banner_2}>
        <div className={styles.banner2_left}>
          <span>Why People Choose Us</span>

          <ul>
            <li>
              <a href="">Affordable Rates</a>
            </li>
            <li>
              <a href="">On Time Service</a>
            </li>{" "}
            <li>
              <a href="">Verified Professionals</a>
            </li>
            <li>
              <a href="">Excellent Service</a>
            </li>
          </ul>
        </div>
        <div className={styles.banner2_right}>
          <img src={bottomBanner2_img} alt="bottomBanner2_img" />
        </div>
      </div>
    </>
  );
};

export default Hero;
